// The SKU is used to build the MediaKey, which becomes the mediaItemId and is
// sent as a single URL path segment. Anything outside this set can break
// routing -- notably "/", which Azure rejects even when percent-encoded.
const DISALLOWED_SKU_CHARS = /[^A-Za-z0-9._-]/g;

export function sanitizeSku(value) {
  return String(value ?? "")
    .replace(DISALLOWED_SKU_CHARS, "")
    .slice(0, 64);
}

export default sanitizeSku;
